import { render, staticRenderFns } from "./StandappLoginComponent.vue?vue&type=template&id=1d6bf802&"
import script from "./StandappLoginComponent.vue?vue&type=script&lang=js&"
export * from "./StandappLoginComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports